import { Action, Dispatch } from 'redux'
import { db } from 'firebase/index'
import { CouponType } from 'types/coupon'
import { getExpiredDate } from 'reducks/coupon/operations'
import { fetchCouponsAction } from 'reducks/coupon/actions'

const fetchCoupons = () => {
  return async (dispatch: Dispatch<Action>) => {
    const coupons = await db
      .collection('coupons')
      .orderBy('created_at', 'desc')
      .get()
      .then((snapshots) => {
        const _coupons: CouponType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as CouponType
          data.coupon_id = snapshot.id
          _coupons.push(data)
        })
        _coupons.sort((a, b) => {
          const aExpiresDate = getExpiredDate(a.expires_at || undefined, a.expires_maxage || 0)
          const bExpiresDate = getExpiredDate(b.expires_at || undefined, b.expires_maxage || 0)
          return aExpiresDate.getTime() > bExpiresDate.getTime() ? -1 : 1
        })
        return _coupons
      })
    dispatch(fetchCouponsAction(coupons))
  }
}

export default fetchCoupons
